export class ArrayUtils {
  public static removeEmptyStrings(array: string[]): any[] {
    return array.filter((element) => element !== '' && element !== null);
  }
}
